<template>
  <div class="page-container page-404">
    <h1>404 page not found.</h1>
    <p>We can't seem to find the page you're looking for.</p>
    <router-link to="/" class="home-link">Go Back Home</router-link>
  </div>
</template>
  
  <style scoped>
  .page-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100vh;
    text-align: center;
    color: #2c3e50;
  }
  
  h1 {
    font-size: 2rem;
    margin-bottom: 10px;
  }
  
  p {
    font-size: 1.2rem;
    margin-bottom: 20px;
  }
  
  .home-link {
    text-decoration: none;
    padding: 10px 20px;
    background-color: #3498db;
    color: #fff;
    border-radius: 5px;
    font-size: 1rem;
  }
  
  .home-link:hover {
    background-color: #2980b9;
  }
  </style>
  